import { useContext, type ReactNode, type FC } from 'react'
import { GoogleMap, useLoadScript, type GoogleMapProps } from '@react-google-maps/api'

import { MapContext } from './MapContext.js'

type Props = GoogleMapProps & {
  children: ReactNode
}

export const Map: FC<Props> = ({ children, ...props }) => {
  const { apiKey, nonce } = useContext(MapContext)

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: apiKey,
    nonce,
  })

  if (isLoaded) {
    return <GoogleMap {...props}>{children}</GoogleMap>
  }

  return null
}
